var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function isDefined(x) {
    return x !== undefined && x !== null;
}
export function assertNever(x, error) {
    if (error === void 0) { error = 'Unexpected object'; }
    throw new Error(error + ": " + JSON.stringify(x));
}
export function toNumber(value) {
    // check type OR truthiness to avoid 0 issues
    return typeof value === 'number' || value ? Number(value) : undefined;
}
/**
 * Returns an object composed from key-value `pairs`.
 *
 * Signature same as lodash, see also https://github.com/tc39/proposal-object-from-entries
 * @param {Array} pairs The key-value pairs.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.fromPairs([['a', 1], ['b', 2]]);
 * // => { 'a': 1, 'b': 2 }
 */
export function fromPairs(values) {
    return values.reduce(function (acc, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        return (__assign({}, acc, (_b = {}, _b[key] = value, _b)));
    }, {});
}
/** A version of JSON.stringify that sorts object keys
 * (and optionally array entries) for a stable sort.
 * Useful for using as an object's hash.
 *
 * Based on https://github.com/substack/json-stable-stringify
 */
export function jsonStableStringify(node, sortArrays) {
    if (sortArrays === void 0) { sortArrays = false; }
    if (node && node.toJSON && typeof node.toJSON === 'function') {
        // eslint-disable-next-line no-param-reassign
        node = node.toJSON();
    }
    if (node === undefined) {
        return;
    }
    if (typeof node !== 'object' || node === null) {
        return JSON.stringify(node);
    }
    if (Array.isArray(node)) {
        return "[" + (sortArrays ? node.slice().sort() : node)
            .map(function (value) { return jsonStableStringify(value, sortArrays) || JSON.stringify(null); })
            .join(',') + "]";
    }
    return "{" + Object.keys(node)
        .sort()
        .map(function (key) {
        var value = jsonStableStringify(node[key], sortArrays);
        return value ? JSON.stringify(key) + ":" + value : undefined;
    })
        .filter(isDefined)
        .join(',') + "}";
}
